module.exports = __webpack_public_path__ + "img/icon-vot-salesanalytic.c9f20c7d.png";